export default {
    computed: {
        isDraft() {
            return this.event.status === "draft";
        },
        isPublished() {
            return this.event.status !== "draft";
        }
    }
}